import { AreaCountAnnotation, ScaleInfo } from "custom-models/ViewerTypes";

import { AnnotationColors } from "./subtree";
import ViewerFacade from "../ViewerFacade";

// Also in Measurement.tsx; to be replaced with something more robust later
const EXPECTED_CHAR_WIDTH = 16;
const EXPECTED_CHAR_HEIGHT = 20;

const FONT_SIZE = 14;

interface AreaCountProps {
  annotation: AreaCountAnnotation;
  scaleInfo: ScaleInfo;
  viewerFacade: ViewerFacade;
  isSelected?: boolean;
}

const AreaCount = (props: AreaCountProps) => {
  const { scaleInfo, annotation } = props;
  const { point, label } = annotation;
  const color = props.isSelected
    ? AnnotationColors.SELECTED
    : props.annotation.id
    ? AnnotationColors.DEFAULT
    : AnnotationColors.ACTIVE;

  const pixelsPerMeter = props.viewerFacade.getPixelsPerMeter();

  // Ten micron radius: divide pixelsPerMeter by 100000
  // If we wanted a circle with a radius of 1 mm:
  // radius = pixelsPerMeter / 1000
  // But we want a *circle* with *area* of 1mm by 1mm, so we must divide further by sqrt(pi)
  const radius =
    point && pixelsPerMeter ? pixelsPerMeter / 1000 / Math.sqrt(Math.PI) : 0;
  const scale = scaleInfo.scaleX;
  const margin = 0;
  const fontSize = Math.floor(FONT_SIZE / scale);
  const textAnchor = "middle";

  const textLength = ((label || "").length * EXPECTED_CHAR_WIDTH) / scale;
  const textHeight = EXPECTED_CHAR_HEIGHT / scale;

  return point && pixelsPerMeter ? (
    <g
      x={point.x}
      y={point.y}
      transform={`rotate(${-scaleInfo.rotation} ${point.x} ${point.y})`}
    >
      <circle
        key="circle"
        cx={point.x}
        cy={point.y}
        r={radius}
        strokeWidth={2.0 / scale}
        stroke={color}
        fill="none"
      />
      {label && (
        <>
          <line
            key="arrow-main"
            x1={point.x}
            x2={point.x}
            y1={point.y + radius}
            y2={point.y + radius + textHeight / 2 - margin}
            strokeWidth={2.0 / scale}
            stroke={color}
          />
          <rect
            key="number-box"
            x={point.x - margin - textLength / 2}
            y={point.y + radius + textHeight / 2 - margin}
            width={textLength + 2 * margin}
            height={textHeight + 2 * margin}
            fill="rgba(240, 240, 240, 0.85)"
            stroke={color}
            strokeWidth={2.0 / scale}
          />
          <text
            key="number-text"
            x={point.x}
            y={point.y + radius + textHeight}
            textAnchor={textAnchor}
            style={{ fontSize: `${fontSize}pt` }}
            fill={color}
            dominantBaseline="central"
          >
            {label}
          </text>
        </>
      )}
    </g>
  ) : null;
};

export default AreaCount;
